import { Token } from '@/types/http'

class AuthService {
  isTokenValid(token: Token, extraMinutes = 1) {
    return Date.now() / 1000 < token.expiresAt - (extraMinutes ? extraMinutes * 60 : 0)
  }
}

export const authService = new AuthService()